import React from 'react';
import PropTypes from 'prop-types';
import { includes } from 'ramda';

import StorePresenter from '../../../../../../presenters/StorePresenter';
import { useFetchStatus } from '../../../../../../utils/fetchStatusUtils';
import ListSkeleton from '../../../../../../components/Skeletons/ListSkeleton';

import StoreCell from './components/StoreCell';

export const StoresTable = (props) => {
  const {
    stores,
    loadingState,
    onStoreCheck,
    onCheckAllClick,
    selectedStoresIds,
    isAllStoresSelected,
  } = props;

  const { isFulfilled } = useFetchStatus(loadingState);

  if (!isFulfilled) {
    return <ListSkeleton height={15} width={500} />;
  }

  const isChecked = (store) => {
    return includes(StorePresenter.id(store), selectedStoresIds);
  };

  return (
    <table className="tables">
      <thead>
        <tr>
          <th onClick={onCheckAllClick} rowSpan="2">
            <input
              type="checkbox"
              id="checkAllStores"
              checked={isAllStoresSelected}
              readOnly
            />
          </th>
          <th rowSpan="2">Store Name</th>
          <th colSpan="2" className="overtitle">
            FastCash Rate
          </th>
        </tr>
        <tr>
          <th className="subtitle">Default</th>
          <th className="subtitle">Birthday</th>
        </tr>
      </thead>
      <tbody>
        {stores.map((store) => (
          <StoreCell
            key={store.id}
            store={store}
            isChecked={isChecked(store)}
            onStoreCheck={onStoreCheck}
          />
        ))}
      </tbody>
    </table>
  );
};

export default StoresTable;

StoresTable.propTypes = {
  stores: PropTypes.arrayOf(StorePresenter.shape()),
  loadingState: PropTypes.string.isRequired,
  onStoreCheck: PropTypes.func.isRequired,
  onCheckAllClick: PropTypes.func.isRequired,
  selectedStoresIds: PropTypes.arrayOf(PropTypes.string),
  isAllStoresSelected: PropTypes.bool.isRequired,
};

StoresTable.defaultProps = {
  stores: [],
  selectedStoresIds: [],
};
